var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighSkillEducaion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Non-Formal_School",
    "data-name": "Non-Formal School",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#ffeff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071",
    transform: "translate(479.15 193.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9953",
    "data-name": "Path 9953",
    d: "M0,0H44.7V44.7H0Z",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9954",
    "data-name": "Path 9954",
    d: "M5,29.625C5.931,21.244,9.656,14.725,18.038,11",
    transform: "translate(4.313 9.488)",
    fill: "rgba(0,0,0,0)",
    stroke: "#c3504f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9955",
    "data-name": "Path 9955",
    d: "M13.325,30.075c11.581,0,19.556-6.124,20.488-22.35V4H26.336C9.574,4,4.012,11.45,3.986,20.763a12.038,12.038,0,0,0,3.725,9.313H13.3Z",
    transform: "translate(3.438 3.45)",
    fill: "rgba(0,0,0,0)",
    stroke: "#c3504f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighSkillEducaion);
export default __webpack_public_path__ + "static/media/ligh-skill-educaion.a2a4298ba0b718bfc1a54cc94de573c9.svg";
export { ForwardRef as ReactComponent };